export default "__VITE_ASSET__BBcdKA3p__"